import { useCallback, useEffect, useRef, useState } from "react";
import { getDevices } from "../api/devices";

// Unregister originates on firmware; update an already-open console quietly.
export default function useDeviceList(loadDevices = getDevices, enabled = true) {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const mounted = useRef(false);
  const inFlight = useRef(null);
  const refresh = useCallback(() => {
    if (inFlight.current) return inFlight.current;
    const request = loadDevices().then((rows) => {
      if (mounted.current) { setDevices(rows); setError(""); }
    }).catch((err) => {
      if (mounted.current) setError(err.message);
    }).finally(() => {
      if (mounted.current) setLoading(false);
      inFlight.current = null;
    });
    inFlight.current = request;
    return request;
  }, [loadDevices]);
  useEffect(() => {
    if (!enabled) return undefined;
    mounted.current = true;
    void refresh();
    const visibleRefresh = () => { if (document.visibilityState !== "hidden") void refresh(); };
    const timer = setInterval(visibleRefresh, 15000);
    window.addEventListener("focus", visibleRefresh);
    document.addEventListener("visibilitychange", visibleRefresh);
    return () => {
      mounted.current = false;
      clearInterval(timer);
      window.removeEventListener("focus", visibleRefresh);
      document.removeEventListener("visibilitychange", visibleRefresh);
    };
  }, [refresh, enabled]);
  return { devices, loading, error, refresh };
}
